
























































































































import Vue from "vue";
import { getEmailsByOrgUnitId, getEmailsSentToMe } from "../helpers/api";
import SentEmailCard from "@/components/Email/SentEmailCard.vue";
import { EmailVO } from "../types/REST-API-DOMAIN/EmailVO";
import Loading from "@/components/Loading.vue";
import { mapGetters } from "vuex";
import GetterTypes from "@/store/GetterTypes";
import iFrameModal from "@/components/common/iFrameModal.vue";
import EmailMessage from "@/components/Email/EmailMessage.vue";
import ReceivedEmailCard from "@/components/Email/ReceivedEmailCard.vue";
import { PermissionKeys, UserOrganizationsAndTeams } from "@/types";
import { bus } from "@/main";

interface State {
  loading: boolean;
  error: any;
  showEmailCreator: boolean;
  loadingEmailIframe: boolean;
  selectedEmail: any;
  sentEmails: Array<EmailVO>;
  receivedEmails: Array<EmailVO>;
}

export default Vue.extend({
  name: "Email",
  metaInfo: {
    title: "Email"
  },
  components: {
    ReceivedEmailCard,
    EmailMessage,
    SentEmailCard,
    Loading,
    iFrameModal
  },
  data: (): State => {
    return {
      loading: false,
      sentEmails: [],
      receivedEmails: [],
      error: null,
      showEmailCreator: false,
      loadingEmailIframe: false,
      selectedEmail: null
    };
  },
  methods: {
    closeEmailCreator() {
      this.showEmailCreator = false;
    },
    async fetchSentEmail(teamId: string | null, orgId: string | null) {
      const orgUnitId: any = teamId ? teamId : orgId;

      this.loading = true;

      if (!orgUnitId) {
        this.receivedEmails = await this.fetchEmails();
      } else {
        this.sentEmails = await getEmailsByOrgUnitId(orgUnitId);
      }

      this.loading = false;
    },
    async fetchEmails(): Promise<Array<EmailVO>> {
      // const mandrillEmails = await this.retrieveMandrillEmailsSentToMe();
      const emails: Array<EmailVO> = await this.getEmailsForSelection();
      emails.sort((a: EmailVO, b: EmailVO) =>
        a.email.dateCreated > b.email.dateCreated ? -1 : 1
      );
      return emails;
    },
    async getEmailsForSelection(): Promise<Array<EmailVO>> {
      return await getEmailsSentToMe();
    },
    handleSelectEmail(email: any) {
      this.selectedEmail = email;
    },
    showEmailIframe() {
      this.showEmailCreator = true;
      this.loadingEmailIframe = true;
    },
    iframeLoaded() {
      this.loadingEmailIframe = false;
    },
    showSubscriptionExpired() {
      bus.$emit("showExpiredSubscription");
    }
  },
  computed: {
    emailUrl(): string {
      return "/email-teams/" + this.selectedOrgUnitId;
    },
    selectedOrgUnitId(): string | null {
      return this.$route.params.teamId || this.$route.params.orgId;
    },
    selectedOrgUnit(): UserOrganizationsAndTeams | null {
      return this.team || this.organization;
    },
    canSendMessages(): boolean {
      return this.hasPermission(PermissionKeys.CAN_SEND_MESSAGES);
    },
    limitedFunctionalityMode(): boolean {
      return this.$route.params.teamId && this.limitedFunctionality;
    },
    ...mapGetters({
      user: GetterTypes.GET_USER,
      playersAndTeams: GetterTypes.GET_PLAYERS_AND_TEAMS,
      team: GetterTypes.GET_TEAM,
      organization: GetterTypes.GET_ORGANIZATION,
      hasPermission: GetterTypes.GET_COACH_HAS_PERMISSION,
      limitedFunctionality: GetterTypes.GET_ORG_HAS_LIMITED_FUNCTIONALITY
    })
  },
  watch: {
    "$route.params": {
      handler: function() {
        const teamId = this.$route.params.teamId;
        const orgId = this.$route.params.orgId;
        this.fetchSentEmail(teamId, orgId);
      },
      immediate: true
    },
    showEmailCreator: function(val) {
      if (!val) {
        const teamId = this.$route.params.teamId;
        const orgId = this.$route.params.orgId;
        this.fetchSentEmail(teamId, orgId);
      }
    }
  }
});
